import { message, Space, Form as FormInitial, Row, Col } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
  ErrorItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import facturaPdf from "../../../../Pdf/facturaPdf";
import remisionPdf from "../../../../Pdf/remisionPdf";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class VistaPreviaVenta extends Component {
  formRef = React.createRef();
  iframeRef = React.createRef();
  urlPdf = null;
  state = {
    loading: false,
    pdf: null,
    factura: false,
    datosPdf: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.consultarTodo();
    }
  }

  componentWillUnmount() {
    if (this.urlPdf) URL.revokeObjectURL(this.urlPdf);
  }

  // `pdf.open` navega el iframe con `location.href` y eso agrega una entrada al historial:
  // después, el `history.goBack()` de la pantalla sólo regresaba el iframe. Con
  // `location.replace` el PDF se muestra sin dejar entrada.
  mostrarPdf(pdf) {
    pdf.getBlob((blob) => {
      const iframe = this.iframeRef.current;
      if (!iframe?.contentWindow) return;
      if (this.urlPdf) URL.revokeObjectURL(this.urlPdf);
      this.urlPdf = URL.createObjectURL(blob);
      iframe.contentWindow.location.replace(this.urlPdf);
    });
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        this.props.endpoint || "ventas/datosPdfPreview",
        { ...this.props.datosVenta, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          if (res.data?.correosEnvio?.length > 0 && this.formRef.current) {
            this.formRef.current.setFieldsValue({
              correosEnvio: res.data.correosEnvio,
            });
          }

          // Guardar datos para el envío por correo
          this.setState({ datosPdf: res.data, factura: res.data.factura });
          const pdfData = { ...res.data, esPreview: true };
          const pdf = res.data.factura
            ? pdfMake.createPdf(facturaPdf(pdfData))
            : pdfMake.createPdf(remisionPdf(pdfData));

          this.setState({ loading: false, pdf }, () => {
            this.mostrarPdf(pdf);
          });
        } else {
          message.error(res.data.message || "No se pudo generar la vista previa");
          this.setState({ loading: false });
        }
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (!values?.correosEnvio?.length) {
      return message.info("Proporcione al menos un correo de envío");
    }

    this.setState({ loading: true });

    // Generamos el PDF en base64 y lo enviamos igual que MandarCorreo
    const { datosPdf } = this.state;
    if (!datosPdf) return;

    const pdf = datosPdf.factura
      ? pdfMake.createPdf(facturaPdf(datosPdf))
      : pdfMake.createPdf(remisionPdf(datosPdf));

    pdf.getBase64((base64) => {
      axios
        .post(
          "ventas/enviarVentaPreview",
          {
            ...this.props.datosVenta,
            empresaId: this.props.empresaId,
            correosEnvio: values.correosEnvio,
            pdfBase64: base64,
            factura: datosPdf.factura,
            serie: datosPdf.respuestaFactura?.dataSat?.Serie,
            folio: datosPdf.respuestaFactura?.dataSat?.Folio,
          },
          { headers: this.props.headersToken },
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success(
              datosPdf.factura
                ? "Vista previa enviada"
                : "Vista previa enviada",
            );
            this.cerrarModal();
          } else {
            message.error("No se pudo enviar el correo");
          }
        });
    });
  }

  cerrarModal() {
    this.props.cerrarVistaPreviaVenta();
    this.formRef.current?.resetFields();
    this.setState({ pdf: null, datosPdf: null, factura: false });
  }

  render() {
    return (
      <ModalItem
        title="Vista previa de venta"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal.bind(this)}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="vistaPreviaVenta"
          layout
          width={700}
          onCancel={this.cerrarModal.bind(this)}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormInitial.List name="correosEnvio" initialValue={[{ correo: "" }]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={arrayKey}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label="Correo"
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem
                          style={{ width: "100%" }}
                          placeholder="Correo"
                        />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: "center" }}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 && (
                  <div style={{ textAlign: "center", marginTop: 5 }}>
                    <ButtonItem
                      type="primary"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      Agregar
                    </ButtonItem>
                  </div>
                )}
              </>
            )}
          </FormInitial.List>

          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginTop: 20,
              marginBottom: 10,
            }}
          >
            <Space>
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Mandar Correo
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                onClick={this.cerrarModal.bind(this)}
              >
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>

        <iframe
          ref={this.iframeRef}
          title="vistaPreviaVenta"
          style={{ width: "100%", height: "100vh" }}
          id="vistaPreviaPdf"
          name="vistaPreviaPdf"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(VistaPreviaVenta);
